import type { DOMOutputSpec } from './../../ricos-types';

// on the outer container the data-breakout attribute is added via decorations
// we give the node additional container so the breakout padding would not clash with node's padding
export function withBreakoutContainer(
  spec: [tag: string, attributes: Record<string, any>, children?: 0 | DOMOutputSpec],
  divAttributes?: any
): DOMOutputSpec {
  return ['div', { ...divAttributes }, spec];
}
